import React, { useState, useEffect } from "react";
import { Button, Card, Table, message } from "antd";
import { PlusOutlined, EditOutlined } from "@ant-design/icons";
import { DatePicker, Input } from "antd";
import dayjs from "dayjs";
import {
  createHoliday,
  getHolidays,
  updateHoliday,
} from "../../../api/holiday/holidayRequest";
import FormModal from "../../../components/FormModal";

function HolidaysTab() {
  const [holidays, setHolidays] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [formData, setFormData] = useState({});

  useEffect(() => {
    fetchHolidays();
  }, []);

  const fetchHolidays = async () => {
    setLoading(true);
    try {
      const data = await getHolidays();
      setHolidays(data);
    } catch (error) {
      message.error("Erreur de chargement des jours fériés");
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async () => {
    if (!formData.date || !formData.description) {
      message.error("Veuillez remplir tous les champs");
      return;
    }
    try {
      if (editingId) {
        await updateHoliday(editingId, formData);
        message.success("Jour férié mis à jour");
      } else {
        await createHoliday({
          ...formData,
          date: dayjs(formData.date).format("YYYY-MM-DD"),
        });
        message.success("Jour férié ajouté");
      }
      handleCloseModal();
      fetchHolidays();
    } catch (error) {
      message.error("Erreur lors de l'enregistrement");
    }
  };

  const handleCloseModal = () => {
    setIsModalVisible(false);
    setFormData({});
    setEditingId(null);
  };

  const columns = [
    { title: "Date", dataIndex: "date", key: "date" },
    { title: "Description", dataIndex: "description", key: "description" },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Button
          icon={<EditOutlined />}
          onClick={() => {
            setFormData(record);
            setEditingId(record.id);
            setIsModalVisible(true);
          }}
        >
          Modifier
        </Button>
      ),
    },
  ];

  return (
    <>
      <Card className="mb-6 shadow-sm">
        <Button
          type="primary"
          icon={<PlusOutlined />}
          onClick={() => setIsModalVisible(true)}
        >
          Ajouter un jour férié
        </Button>
      </Card>

      <Table
        columns={columns}
        dataSource={holidays}
        loading={loading}
        rowKey="id"
      />

      <FormModal
        title={editingId ? "Modification" : "Nouveau jour férié"}
        visible={isModalVisible}
        onOk={handleSubmit}
        onCancel={handleCloseModal}
      >
        <DatePicker
          format="DD/MM/YYYY"
          placeholder="Date"
          value={formData.date ? dayjs(formData.date) : null}
          onChange={(date) =>
            setFormData({ ...formData, date: date?.format("YYYY-MM-DD") })
          }
          className="w-full mb-3"
        />
        <Input
          placeholder="Description"
          value={formData.description}
          onChange={(e) =>
            setFormData({ ...formData, description: e.target.value })
          }
        />
      </FormModal>
    </>
  );
}

export default HolidaysTab;
